/** Ids of `fulfillment.sales_order_return_source`, seeded by migration 20261105120000: why a return waits in Receiving. */
export var SalesOrderReturnSource;
(function (SalesOrderReturnSource) {
    SalesOrderReturnSource[SalesOrderReturnSource["REJECTED"] = 1] = "REJECTED";
    SalesOrderReturnSource[SalesOrderReturnSource["FAILED_DELIVERY"] = 2] = "FAILED_DELIVERY";
    SalesOrderReturnSource[SalesOrderReturnSource["RMA"] = 3] = "RMA";
})(SalesOrderReturnSource || (SalesOrderReturnSource = {}));
//# sourceMappingURL=sales-order-return-source.js.map